import ReactGA from 'react-ga4';
import AnalyticsEvent from '../AnalyticsEvent';
import AnalyticsService from '../AnalyticsService';
import { GoogleAnalyticsEvent } from '../events';

type GoogleAnalyticsServiceParams = {
  measurementIds: string[];
  debugMode?: boolean;
};

class GoogleAnalyticsService extends AnalyticsService {
  trackingEvents = Object.keys(GoogleAnalyticsEvent)
    .filter(value => !Number.isNaN(Number(value)))
    .map(key => GoogleAnalyticsEvent[key as any]);

  constructor(params: GoogleAnalyticsServiceParams) {
    super();
    const gtagOptions: Record<string, any> = {};
    if (params.debugMode) {
      gtagOptions['debug_mode'] = true;
    }
    ReactGA.initialize(
      params.measurementIds.map(measurementId => ({
        trackingId: measurementId,
        gtagOptions: gtagOptions,
      })),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setUserId(userId: string): void {
    // Method not implemented.
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setUserProperties(properties: Record<string, unknown>): void {
    // Method not implemented.
  }

  track(event: AnalyticsEvent, properties?: Record<string, unknown>): void {
    ReactGA.event(AnalyticsEvent[event], properties);
  }
}

export default GoogleAnalyticsService;
